import { useEffect } from "react";
import { homeContent } from "../data/mockHome";
import { HeroSection } from "../components/home/HeroSection";
import { PillarsSection } from "../components/home/PillarsSection";
import { SectorsSection } from "../components/home/SectorsSection";
import { CaseStudiesSection } from "../components/home/CaseStudiesSection";
import { HowItWorksSection } from "../components/home/HowItWorksSection";
import { KPISection } from "../components/home/KPISection";
import { SocialProofSection } from "../components/home/SocialProofSection";
import { FinalCTASection } from "../components/home/FinalCTASection";

export function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="bg-slate-950 text-slate-100">
      <HeroSection {...homeContent.hero} />
      <PillarsSection pillars={homeContent.pillars} />
      <SectorsSection sectors={homeContent.sectors} />
      <CaseStudiesSection caseStudies={homeContent.caseStudies} />
      <HowItWorksSection {...homeContent.howItWorks} />
      <KPISection kpis={homeContent.kpiStrip} />
      <SocialProofSection {...homeContent.socialProof} />
      <FinalCTASection {...homeContent.finalCta} />
      <footer className="bg-slate-950/95 py-12">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-6 px-6 text-xs text-slate-400">
          <nav aria-label="Footer">
            <ul className="flex flex-wrap gap-4">
              <li>
                <a href="#speaking" className="hover:text-emerald-200">
                  Speaking & Workshops
                </a>
              </li>
              <li>
                <a href="#newsletter" className="hover:text-emerald-200">
                  Newsletter / Insights
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com" className="hover:text-emerald-200">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="#privacy" className="hover:text-emerald-200">
                  Privacy / Terms
                </a>
              </li>
            </ul>
          </nav>
          <p>© {new Date().getFullYear()} AVUX Consulting. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
